import button from './Button'
import ThrottleButton from './Button/ThrottleButton'
import table from './Table'
import chart from './Chart'
import tags from './Tags'
import title from './Title'
import capsule from './Capsule'
import card from './Card'
import input from './Input'
import tabs from './Tabs'
import datePicker from './DatePicker'
import alForm from './AlForm'
import alSwitch from './Switch'
import InputNum from './InputNum'
import Cascader from './Cascader'
import Select from './Select'
import Radio from './Radio'
import Checkbox from './Checkbox'
import Pagination from './Pagination'
import AlRow from './Row'
import AlCol from './Col'
import AlLabel from './Label'
import AlContainer from './Container'
import AlHeader from './Header'
import AlAside from './Aside'
import AlMain from './Main'
import AlFooter from './Footer'
import AlShowMore from './ShowMore'
import navMenu from './Menu'
import AlDial from './Dial'
import AlSlider from './Slider'
import AlDropdown from './Dropdown'
import TableColumn from './TableColumn'
import AlColumsGroup from './ColumsGroup'
import AlHeadImg from './HeadImg'
import AlCoverImg from './CoverImg'
import AlPopover from './Popover'
import AlMessage from './Message'
import AlBackToTop from './BackToTop'
const components = {
    'AlButton':button,
    'AlThrottleButton':ThrottleButton,
    'AlTable':table,
    'AlLineChart':chart,
    'AlTags':tags,
    'AlCapsule':capsule,
    'AlTitle':title,
    'AlCard':card,
    'AlInput':input,
    'AlTabs' :tabs,
    'AlDatePicker' :datePicker,
    'AlSwitch' :alSwitch,
    'AlForm' :alForm,
    'AlInputNum' :InputNum,
    'AlCascader' :Cascader,
    'AlSelect' :Select,
    'AlRadio' :Radio,
    'AlCheckbox' :Checkbox,
    'AlPagination' :Pagination,
    'AlRow' :AlRow,
    'AlCol' :AlCol,
    'AlLabel' :AlLabel,
    'AlContainer' :AlContainer,
    'AlHeader' :AlHeader,
    'AlAside' :AlAside,
    'AlMain' :AlMain,
    'AlFooter' :AlFooter,
    'AlShowMore' :AlShowMore,
    'AlMenu' :navMenu,
    'AlDial' :AlDial,
    'AlSlider' :AlSlider,
    'AlDropdown' :AlDropdown,
    'AlTableColumn' :TableColumn,
    'AlColumsGroup':AlColumsGroup,
    'AlHeadImg':AlHeadImg,
    'AlCoverImg':AlCoverImg,
    'AlPopover':AlPopover,
    'AlMessage':AlMessage,
    'AlBackToTop':AlBackToTop,
};
//加载样式css
var loadStyle = function(url) {
  var link = document.createElement('link');
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = url;
  var head = document.getElementsByTagName("head")[0];
  head.appendChild(link);
};

// css加载
loadStyle('https://at.alicdn.com/t/font_1819820_227wwgafqrd.css');
// loadStyle('https://element.eleme.cn/element-ui.ead51c9.css');
const ins = function(Vue, opts = {}) {
    Object.keys(components).forEach((key) => {
        Vue.component(key, components[key]);
    });
};
export default ins;




// WEBPACK FOOTER //
// ./UI/index.js